import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import logger from 'loglevel';

import { fullClientRoutes } from '@flb/common/client-routes';
import { AnySupportRequestUpdate } from '@flb/common/support-request';
import { AccessLevel } from '@flb/common/access-level';

import { ParamKey } from './support-request.component.js';
import { ClientStateService } from '../common/client-state.service.js';
import { SupportRequestNotificationService } from './support-request-notification.service.js';

export class SupportRequestNotificationParams {
    constructor(public readonly sru: AnySupportRequestUpdate) {}
}

@Component({
    selector: 'flb-support-request-notification',
    standalone: true,
    imports: [],
    template: `
        <div class="link"><a href="{{ listRoute }}#{{ fragment }}" (click)="navigate()"></a></div>
        {{ content }}
    `,
    styleUrl: './support-request-notification.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportRequestNotificationComponent {
    listRoute: string;
    fragment: string;
    content: string;
    constructor(
        params: SupportRequestNotificationParams,
        clientState: ClientStateService,
        supportRequestNotification: SupportRequestNotificationService,
        private router: Router
    ) {
        const admin = clientState.authToken.value?.accessLevel !== AccessLevel.Player;
        this.listRoute = admin
            ? fullClientRoutes.adminSupportRequestList
            : fullClientRoutes.supportRequestList;
        this.fragment = `${ParamKey.RequestId}=${params.sru.id}`;
        this.content = supportRequestNotification.supportRequestUpdateToString(params.sru);
    }

    navigate() {
        //# TODO: this doesn't work!
        this.router
            .navigate([this.listRoute], {
                fragment: this.fragment,
                onSameUrlNavigation: 'reload'
            })
            .catch(ex => logger.error('SupportRequestNotification navigate', ex));
    }
}
